export function storefrontProductTitle(product = {}) {
  const code = String(product.productCode || '').trim();
  let name = String(product.onlineName || product.title || product.name || code || 'Untitled Product').trim();
  if (code && name.toLowerCase() === code.toLowerCase()) name = code;
  return name;
}
